import { useMutation, useQuery } from "@tanstack/react-query";
import { Button, Space, Table, Tabs, Typography, message } from "antd";
import React from "react";
import {
  acceptDenyRedeemRequest,
  getRedeemRequest,
  getSystemValue,
} from "../utils/api";
import { useAuth } from "../utils/store";

const RedeemRequest = () => {
  const user = useAuth((state) => state.user);
  const [messageApi, contextHolder] = message.useMessage();

  const { data: systemData } = useQuery({
    queryKey: ["dashboard"],
    queryFn: async () => await getSystemValue(),
  });

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["redeem-requests"],
    queryFn: async () => await getRedeemRequest(),
  });

  const { mutate } = useMutation({
    mutationFn: async ({ id, request }) =>
      await acceptDenyRedeemRequest(id, request),
    onSuccess: (data) => {
      messageApi.success(data.message);
      refetch();
    },
    onError: (err) => {
      messageApi.error(err?.response?.data?.message);
    },
  });

  const columns = [
    {
      title: "Created At",
      dataIndex: "createdAt",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "User Name",
      dataIndex: ["user", "name"],
    },
    {
      title: "User Email",
      dataIndex: ["user", "email"],
    },
    {
      title: "Withdrawable Coins",
      render: (_, record) =>
        record.user.totalCoin - (systemData?.systemValues?.adminCharges || 0),
    },
    {
      title: "UPI",
      dataIndex: ["user", "upi"],
    },
    {
      title: "Aadhar Number",
      dataIndex: ["user", "aadharNumber"],
    },
    {
      title: "Account Number",
      dataIndex: ["user", "accountNumber"],
    },
    {
      title: "Bank Name",
      dataIndex: ["user", "bankName"],
    },
    {
      title: "Branch Name",
      dataIndex: ["user", "branchName"],
    },
    {
      title: "IFSC",
      dataIndex: ["user", "ifsc"],
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Space direction="vertical">
          <Button
            type="primary"
            onClick={() =>
              mutate({
                id: record._id,
                request: {
                  status: "Completed",
                  message: "Redeem Request has been accepted",
                  userId: record.user._id,
                },
              })
            }
          >
            Approve
          </Button>
          <Button
            danger
            onClick={() =>
              mutate({
                id: record._id,
                request: {
                  status: "Decline",
                  message: "Redeem Request has been Declined",
                  userId: record.user._id,
                },
              })
            }
          >
            Decline
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      {contextHolder}
      <Typography.Title level={4}>Redeem Requests</Typography.Title>

      <Tabs
        defaultActiveKey="1"
        items={[
          {
            key: "1",
            label: "New Requests",
            children: (
              <Table
                columns={columns}
                dataSource={data?.created}
                loading={isLoading}
                scroll={{ x: 1500 }}
              />
            ),
          },
          {
            key: "2",
            label: "Completed",
            children: (
              <Table
                columns={columns.filter((col) => col.title !== "Actions")}
                dataSource={data?.completed}
                scroll={{ x: 1500 }}
              />
            ),
          },
          {
            key: "3",
            label: "Declined",
            children: (
              <Table
                columns={columns.filter((col) => col.title !== "Actions")}
                dataSource={data?.decline}
                scroll={{ x: 1500 }}
              />
            ),
          },
        ]}
      />
    </div>
  );
};

export default RedeemRequest;
